import React from "react";
import {
  Row, Col, Button, Badge as BadgeUI, Input, Collapse,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import Swal from "sweetalert2";
import api from "./../../../Api.js";

var LETTERS = ['A', 'B', 'C', 'D'];

var DIFFICULTIES = [
  { value: 1, label: 'Fácil 🐌', color: 'success' },
  { value: 2, label: 'Média ⚔️', color: 'info' },
  { value: 3, label: 'Difícil 🔥', color: 'warning' },
  { value: 4, label: 'Boss 🐉', color: 'danger' }
];

/**
 * QuestionBankModal — banco de perguntas da turma (painel do Mestre do Jogo).
 * Lista, cria e exclui perguntas usadas pelos inimigos/eventos da sessão.
 */
class QuestionBankModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      loading: false,
      saving: false,
      formOpen: false,
      question: '',
      options: ['', '', '', ''],
      correctIndex: 0,
      difficulty: 1,
      xpReward: 20,
      goldReward: 10,
      explanation: ''
    };
  }

  componentDidMount() {
    if (this.props.isOpen) this.loadQuestions();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) this.loadQuestions();
  }

  notify(type, title, message) {
    if (this.props.notify) this.props.notify(type, title, message);
  }

  async loadQuestions() {
    if (!this.props.classroom) return;
    this.setState({ loading: true });
    try {
      var res = await api.dmListQuestions(this.props.classroom);
      var questions = res.data || [];
      this.setState({
        questions: questions,
        loading: false,
        formOpen: this.state.formOpen || questions.length === 0
      });
      if (this.props.onCountChange) this.props.onCountChange(questions.length);
    } catch (e) {
      this.setState({ loading: false });
      this.notify('danger', 'Erro', 'Falha ao carregar as perguntas da turma');
    }
  }

  setOption(index, value) {
    var options = this.state.options.slice();
    options[index] = value;
    this.setState({ options: options });
  }

  resetForm() {
    this.setState({
      question: '',
      options: ['', '', '', ''],
      correctIndex: 0,
      difficulty: 1,
      xpReward: 20,
      goldReward: 10,
      explanation: ''
    });
  }

  async createQuestion() {
    if (this.state.saving) return;

    if (!this.state.question.trim()) {
      this.notify('warning', 'Faltou o enunciado!', 'Escreva a pergunta antes de cadastrar');
      return;
    }
    for (var i = 0; i < 4; i++) {
      if (!this.state.options[i] || !this.state.options[i].trim()) {
        this.notify('warning', 'Faltou a opção ' + LETTERS[i] + '!', 'Preencha as 4 opções de resposta');
        return;
      }
    }

    this.setState({ saving: true });
    try {
      await api.dmCreateQuestion({
        classroom: this.props.classroom,
        question: this.state.question.trim(),
        options: this.state.options.map(function (o) { return o.trim(); }),
        correctIndex: parseInt(this.state.correctIndex),
        explanation: this.state.explanation.trim(),
        difficulty: parseInt(this.state.difficulty),
        xpReward: parseInt(this.state.xpReward) || 20,
        goldReward: parseInt(this.state.goldReward) || 10
      });
      this.setState({ saving: false });
      this.notify('success', '📚 Pergunta cadastrada!', 'Os inimigos agora têm mais um desafio');
      this.resetForm();
      await this.loadQuestions();
    } catch (e) {
      this.setState({ saving: false });
      var msg = (e.response && e.response.data && e.response.data.error) || 'Falha ao cadastrar a pergunta';
      this.notify('danger', 'Erro', msg);
    }
  }

  async deleteQuestion(q) {
    var label = (q.question || '').length > 60 ? q.question.substring(0, 60) + '...' : q.question;
    var confirm = await Swal.fire({
      title: 'Excluir pergunta?',
      html: '<em>"' + label + '"</em><br/><br/>Ela não aparecerá mais nos desafios da turma.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: '<i class="fas fa-trash"></i> Excluir',
      cancelButtonText: '<i class="fas fa-times"></i> Cancelar'
    });
    if (!confirm.isConfirmed) return;
    try {
      await api.dmDeleteQuestion(q.id);
      this.notify('info', 'Pergunta excluída', 'Ela não aparecerá mais nos desafios');
      await this.loadQuestions();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || 'Falha ao excluir a pergunta';
      this.notify('danger', 'Erro', msg);
    }
  }

  difficultyInfo(d) {
    var found = DIFFICULTIES.filter(function (x) { return x.value === parseInt(d); })[0];
    return found || DIFFICULTIES[0];
  }

  renderForm() {
    return (
      <div className="mb-3" style={{ background: '#f8f9fa', borderRadius: '8px', padding: '16px', border: '1px solid #eee' }}>
        <div className="mb-3">
          <label className="form-control-label">Enunciado *</label>
          <Input
            type="textarea"
            rows="2"
            placeholder="ex: O que o comando 'repetir 10 vezes' faz no Scratch?"
            value={this.state.question}
            onChange={(e) => this.setState({ question: e.target.value })}
          />
        </div>

        <Row>
          {LETTERS.map((letter, idx) => (
            <Col md="6" key={letter} className="mb-2">
              <label className="form-control-label">
                Opção {letter} * {parseInt(this.state.correctIndex) === idx && <span style={{ color: '#2dce89' }}>✔ correta</span>}
              </label>
              <Input
                type="text"
                placeholder={'Resposta ' + letter}
                value={this.state.options[idx]}
                onChange={(e) => this.setOption(idx, e.target.value)}
              />
            </Col>
          ))}
        </Row>

        <Row className="mt-2">
          <Col md="3" className="mb-2">
            <label className="form-control-label">Correta</label>
            <Input
              type="select"
              value={this.state.correctIndex}
              onChange={(e) => this.setState({ correctIndex: e.target.value })}
            >
              {LETTERS.map((letter, idx) => (
                <option key={letter} value={idx}>{letter}</option>
              ))}
            </Input>
          </Col>
          <Col md="3" className="mb-2">
            <label className="form-control-label">Dificuldade</label>
            <Input
              type="select"
              value={this.state.difficulty}
              onChange={(e) => this.setState({ difficulty: e.target.value })}
            >
              {DIFFICULTIES.map((d) => (
                <option key={d.value} value={d.value}>{d.value} - {d.label}</option>
              ))}
            </Input>
          </Col>
          <Col md="3" className="mb-2">
            <label className="form-control-label">⚡ XP</label>
            <Input
              type="number"
              min="1"
              value={this.state.xpReward}
              onChange={(e) => this.setState({ xpReward: e.target.value })}
            />
          </Col>
          <Col md="3" className="mb-2">
            <label className="form-control-label">🪙 Gold</label>
            <Input
              type="number"
              min="0"
              value={this.state.goldReward}
              onChange={(e) => this.setState({ goldReward: e.target.value })}
            />
          </Col>
        </Row>

        <div className="mb-3">
          <label className="form-control-label">Explicação (opcional, aparece quando o aluno erra)</label>
          <Input
            type="textarea"
            rows="2"
            placeholder="ex: O bloco repetir executa os comandos dentro dele N vezes"
            value={this.state.explanation}
            onChange={(e) => this.setState({ explanation: e.target.value })}
          />
        </div>

        <div className="text-right">
          <Button color="success" onClick={() => this.createQuestion()} disabled={this.state.saving}>
            {this.state.saving ? (
              <React.Fragment><i className="fas fa-spinner fa-spin mr-1" /> Cadastrando...</React.Fragment>
            ) : (
              <React.Fragment><i className="fas fa-plus mr-1" /> Cadastrar Pergunta</React.Fragment>
            )}
          </Button>
        </div>
      </div>
    );
  }

  renderQuestion(q) {
    var diff = this.difficultyInfo(q.difficulty);
    return (
      <div key={q.id} className="mb-3" style={{ border: '1px solid #eee', borderRadius: '8px', padding: '14px' }}>
        <div className="d-flex justify-content-between align-items-start">
          <h6 className="mb-2" style={{ flex: 1, paddingRight: '10px' }}>{q.question}</h6>
          <Button
            size="sm"
            color="danger"
            outline
            title="Excluir pergunta"
            onClick={() => this.deleteQuestion(q)}
          >
            <i className="fas fa-trash" />
          </Button>
        </div>

        <div className="mb-2">
          <BadgeUI color={diff.color} pill className="mr-2">{diff.value} - {diff.label}</BadgeUI>
          <BadgeUI color="primary" pill className="mr-2">⚡ {q.xpReward || 0} XP</BadgeUI>
          <BadgeUI color="warning" pill>🪙 {q.goldReward || 0} Gold</BadgeUI>
        </div>

        {(q.options || []).map((opt, idx) => {
          var isCorrect = idx === parseInt(q.correctIndex);
          return (
            <div
              key={idx}
              style={{
                padding: '4px 10px',
                borderRadius: '6px',
                marginBottom: '2px',
                background: isCorrect ? '#d4f5e5' : 'transparent',
                color: isCorrect ? '#1a7f4f' : '#525f7f',
                fontWeight: isCorrect ? 600 : 400,
                fontSize: '0.85rem'
              }}
            >
              <strong>{LETTERS[idx] || '?'})</strong> {opt}
              {isCorrect && <i className="fas fa-check ml-2" />}
            </div>
          );
        })}

        {q.explanation && (
          <small className="text-muted d-block mt-2">
            <i className="fas fa-info-circle mr-1" /> {q.explanation}
          </small>
        )}
      </div>
    );
  }

  render() {
    var questions = this.state.questions;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle}>
          📚 Banco de Perguntas
          {questions.length > 0 && (
            <BadgeUI color="primary" pill className="ml-2">{questions.length}</BadgeUI>
          )}
        </ModalHeader>
        <ModalBody>
          <Button
            color={this.state.formOpen ? 'secondary' : 'success'}
            size="sm"
            block
            className="mb-3"
            onClick={() => this.setState({ formOpen: !this.state.formOpen })}
          >
            {this.state.formOpen ? (
              <React.Fragment><i className="fas fa-chevron-up mr-1" /> Esconder formulário</React.Fragment>
            ) : (
              <React.Fragment><i className="fas fa-plus mr-1" /> Nova Pergunta</React.Fragment>
            )}
          </Button>

          <Collapse isOpen={this.state.formOpen}>
            {this.renderForm()}
          </Collapse>

          <hr className="my-3" />

          {this.state.loading ? (
            <div className="text-center py-4"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
          ) : questions.length === 0 ? (
            <div className="text-center py-4 text-muted">
              <i className="fas fa-scroll fa-3x mb-2" style={{ opacity: 0.3 }} />
              <p className="mb-0">Nenhuma pergunta ainda. Sem perguntas os inimigos não têm desafio! 🐉</p>
            </div>
          ) : (
            questions.map((q) => this.renderQuestion(q))
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.toggle}>Fechar</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default QuestionBankModal;
